import React, { FC, useEffect, useState } from "react";
import { useSigma } from "@react-sigma/core"; //"react-sigma-v2";

//import { VERSION } from "../../../config/constant";

import { FiltersState } from "./types";

// import styles from "./Root.module.css";
//import './Root.scoped.css';

const VERSION = process.env.REACT_APP_VERSION;

function prettyPercentage(val: number): string {
  return (val * 100).toFixed(1) + "%";
}
interface GraphTitleProps {
  filters: FiltersState;
  graphString: string; // New prop
}

const GraphTitle: FC<GraphTitleProps> = ({ filters, graphString }) => {
  const sigma = useSigma();
  const graph = sigma.getGraph();

  const [visibleItems, setVisibleItems] = useState<{ nodes: number; edges: number }>({ nodes: 0, edges: 0 });
  useEffect(() => {
    // To ensure the graphology instance has up to data "hidden" values for
    // nodes, we wait for next frame before reindexing. This won't matter in the
    // UX, because of the visible nodes bar width transition.
    requestAnimationFrame(() => {
      const index = { nodes: 0, edges: 0 };
      graph.forEachNode((_, { hidden }) => !hidden && index.nodes++);
      graph.forEachEdge((_, _2, _3, _4, source, target) => !source.hidden && !target.hidden && index.edges++);
      setVisibleItems(index);
    });
  }, [filters]);

  return (
    <div className="graph-title">
      {/* <div className={styles["graph-title"]}> */}
      <h1 text-align="center">{`AI-SNIPS v${VERSION}`}</h1>
      <h1>{graphString}</h1>
      {/* <h2>Version 20221207</h2> */}
      <h3>
        <i>
          {graph.order} node{graph.order > 1 ? "s" : ""}{" "}
          {visibleItems.nodes !== graph.order
            ? ` (only ${prettyPercentage(visibleItems.nodes / graph.order)} visible)`
            : ""}
          , {graph.size} edge
          {graph.size > 1 ? "s" : ""}{" "}
          {visibleItems.edges !== graph.size
            ? ` (only ${prettyPercentage(visibleItems.edges / graph.size)} visible)`
            : ""}
        </i>
      </h3>
    </div>
  );
};

export default GraphTitle;
